import React from "react";
import "./ERP.css";
import SEO from "../../SEO";
const softwareServices = [
  {
    title: "Point Of Sale (POS) System",
    description:
      "Our advanced Point of Sale (POS) system is designed for retail stores, supermarkets, restaurants, and wholesale businesses. It provides fast billing, barcode scanning, inventory tracking, and real-time sales reporting. The system supports both desktop and mobile devices to ensure seamless checkout operations.",
    features: [
      "Fast Billing System",
      "Barcode Scanning",
      "Thermal Receipt Printing",
      "Inventory Management",
      "Discount & Tax Management",
      "Sales Reporting",
      "Mobile POS Support",
    ],
    img: process.env.PUBLIC_URL + "/img/desktop-app.gif",
    icon: "bi-receipt",
  },
  {
    title: "POS ERP Management System",
    description:
      "Our complete POS ERP solution integrates sales, inventory, accounts, HRMS, and reporting into one powerful platform. Available as Desktop Application, Web Application, and Mobile App, it enables real-time data synchronization, centralized control, and business automation across multiple branches.",
    features: [
      "Desktop Application",
      "Web Application",
      "Mobile App",
      "Accounts & Finance Module",
      "HRMS & Payroll",
      "Employee Attendance",
      "Barcode & Stock Control",
      "Multi-Branch Management",
      "Role-Based Access",
      "Cloud Backup & Reports",
    ],
    img: process.env.PUBLIC_URL + "/img/ERP-Management-System-Gif.gif",
    icon: "bi-diagram-3",
  },
];

function ERP() {
  return (
    <>
      <SEO
        title="POS System for Shops & Restaurants in Pakistan | MZR Software"
        description="Get advanced POS system for retail shops, supermarkets and restaurants with billing, inventory, barcode and reporting features."
        url="/pos-system"
      />
      <div className="custom-software-page">
        <section className="services-section">
          <div className="container">
            <div className="section-header">
              <h1 className="section-title">
                POS System for Shops, Retail & Restaurants in Pakistan
              </h1>
              <p className="section-subtitle">
                Powerful POS system with billing, inventory management, barcode
                scanning, accounting and real-time reporting for businesses in
                Pakistan.
              </p>
            </div>

            <div className="services-grid">
              {softwareServices.map((service, index) => (
                <div
                  key={index}
                  className={`service-card zig-zag ${
                    index % 2 === 0 ? "left" : "right"
                  }`}
                >
                  {/* Content */}
                  <div className="card-content">
                    <span className={`bi ${service.icon} service-icon`}></span>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="service-features">
                      {service.features.map((feature, i) => (
                        <span key={i} className="feature-tag">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Image */}
                  <div className="card-image">
                    <img
                      src={service.img}
                      alt={`POS system ${service.title} software`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <div className="text-center text-white mt-5">
          <h2>Best POS System in Pakistan for Business Management</h2>
          <p style={{ maxWidth: "800px", margin: "0 auto" }}>
            Our POS system helps retail shops, supermarkets and restaurants
            manage billing, inventory, accounts and sales reports efficiently.
            Designed for fast performance and easy use, our solution improves
            business operations and increases productivity.
          </p>
        </div>
        <div className="text-center mt-5">
          <h2>Start Your POS System Today</h2>
          <p>Contact us now and get your POS system setup quickly.</p>

          <a
            href="https://wa.me/923351206586?text=Hi%20I%20need%20POS%20system"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            🚀 Get Free Consultation
          </a>
        </div>
      </div>
    </>
  );
}

export default ERP;
